(function(angular) {
    'use strict';

    angular.module('aprima-provider-api').factory('DosingService', [
        '$q',
        'DosingServiceTs',
        DosingService,
    ]);

    function DosingService(
        $q,
        DosingServiceTs
    ) {
        
        var service = {
            convertToCommonUnit: convertToCommonUnit,
            getDoseRangeInfo: getDoseRangeInfo,
            getMinMaxWarning: getMinMaxWarning,
            getDosingDetailsFull: getDosingDetailsFull,
            getVariableDoseRanges: getVariableDoseRanges,
            mapDoseParams: mapDoseParams
        };

        return service;

        function getDoseRangeInfo(
            ageInDays,
            medId,
            gcnSeqNo,
            weightKg,
            heightCm,
            gestationalAge,
            doseTypeIndicator,
            icdCode
        ) {
            var promise = DosingServiceTs.getDoseRangeInfo(
                ageInDays,
                medId,
                gcnSeqNo,
                weightKg,
                heightCm,
                gestationalAge,
                doseTypeIndicator,
                icdCode
            ).toPromise();
            return $q.when(promise);
        }

        function getMinMaxWarning(sigInstructions, rxParameters, patientDetails) {
            var promise = DosingServiceTs.getMinMaxWarning(sigInstructions, rxParameters, patientDetails).toPromise();
            return $q.when(promise);
        }

        function mapDoseParams(sigInstructions, rxParameters, patientDetails){
            return DosingServiceTs.mapDoseParams(sigInstructions, rxParameters, patientDetails);
        }

        function convertToCommonUnit(dosageUnits, dosageAmount) {
            return DosingServiceTs.convertToCommonUnit(dosageUnits, dosageAmount);
        }

        function getDosingDetailsFull(visitId, patientId, defaultValue) {
            var promise = DosingServiceTs.getDosingDetailsFull(visitId, patientId, defaultValue).toPromise();
            return $q.when(promise);
        }

        function getVariableDoseRanges(gcnSeqNo) {
            var promise = DosingServiceTs.getVariableDoseRanges(gcnSeqNo).toPromise();
            return $q.when(promise);
        }
    }
})(window.angular);
